import FlavourConfig from '../../../../shared/config/flavours';
import Modals from '../../../../shared/types/enums/modals';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';
import { store } from '../../../../shared/store/store';

const getModalStyle = (src: string) => {
  const { modal } = store.getState();
  switch (modal.current) {
    case Modals.ACTIVATE_GENERIC:
    case Modals.ACTIVATE_ZAPPER:
    case Modals.ANONYMOUS_GENERIC:
    case Modals.ANONYMOUS_ZAPPER:
      return {
        width: `${400 * Screen.widthRatio}px;`,
      };
    case Modals.PARENTAL_PIN_GENERIC:
    case Modals.PARENTAL_PIN_ZAPPER:
      return {
        left: '0',
        margin: 'auto',
        position: 'absolute',
        right: '0',
        width: `${186 * Screen.widthRatio}px;`,
      };
    case Modals.PLAYER_ERROR:
      return {
        height: `${260 * Screen.widthRatio}px`,
        margin: `${30 * Screen.widthRatio}px auto`,
        position: 'unset',
        width: 'auto',
      };
    case Modals.RECORDING_DELETE:
      return {
        position: 'relative',
        top: '0',
        width: `${
          !src ? FlavourConfig.sizes.recordModalLogo : 160 * Screen.widthRatio
        }px;`,
      };
    case Modals.RECORDING_REQUEST:
      return {
        margin: `0 0 ${12 * Screen.widthRatio}px 0`,
        position: 'relative',
        top: '0',
        width: `${186 * Screen.widthRatio}px;`,
      };
  }
  return '';
};

const ModalLogo = styled.img<{ src: string }>`
  align-self: center;
  height: auto;
  left: 0;
  right: 0;
  top: ${120 * Screen.widthRatio}px;
  margin: auto;
  overflow: hidden;
  position: absolute;
  width: ${FlavourConfig.sizes.anoymousModalLogo}px;
  ${(props) => getModalStyle(props.src)}
}`;

ModalLogo.defaultProps = {
  src: FlavourConfig.images.logo,
};

export default withImage(ModalLogo);
